import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { advanceBenchmarkSelector, benchmarkSelector } from '@store/common/selectors';
import { filterSelector, selectedKPIConfigSelector } from '@store/overviewDashboard/base/selectors';
import { initBenchmark } from '@store/overviewDashboard/benchmark/actions';
import { isKpiValid } from '@components/overview-dashboard/metrics-container/sub-opportunities/Helper';
import { dimensionsListSelector } from '@store/common/dimensionList/selectors';
import { supportedMetricsSelector } from '@store/overviewDashboard/benchmark/selectors';
import {
  benchmarkAndDimensionAndMetricSupported,
  benchmarkSupportedAndFilterApplied,
} from './utils';

export function useIsDimensionSupportedAndFilterApplied(dimension, selectedKpiMetric) {
  const appliedFilter = useSelector(filterSelector);
  const isBenchmarkAndDimensionAndMetricSupported = useIsDimensionSupported(
    dimension,
    selectedKpiMetric,
  );
  const isBenchmarkSupportedAndFilterApplied = useMemo(() => {
    return benchmarkSupportedAndFilterApplied(
      dimension,
      isBenchmarkAndDimensionAndMetricSupported,
      appliedFilter,
    );
  }, [dimension, isBenchmarkAndDimensionAndMetricSupported, appliedFilter]);
  return isBenchmarkSupportedAndFilterApplied;
}

export function useIsDimensionSupported(dimension, selectedKpiMetric) {
  const benchmarkFlag = useSelector(benchmarkSelector);
  const advancedBenchmarkFlag = useSelector(advanceBenchmarkSelector);
  const supportedMetricsStore = useSelector(supportedMetricsSelector);
  const selectedKPIConfig = useSelector(selectedKPIConfigSelector);
  const allDimension = useSelector(dimensionsListSelector);
  const isBenchmarkAndDimensionAndMetricSupported = useMemo(() => {
    return benchmarkAndDimensionAndMetricSupported({
      dimension,
      supportedMetricsStore,
      selectedKpiMetric,
      benchmarkFlag,
      advancedBenchmarkFlag,
      allDimension,
    });
  }, [
    dimension,
    selectedKpiMetric,
    supportedMetricsStore,
    benchmarkFlag,
    advancedBenchmarkFlag,
    allDimension,
  ]);
  return isBenchmarkAndDimensionAndMetricSupported && isKpiValid(selectedKPIConfig);
}

export function useInitBenchmark(dimension, isBenchmarkAndDimensionAndMetricSupported) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (isBenchmarkAndDimensionAndMetricSupported) {
      dispatch(initBenchmark(dimension));
    }
  }, [isBenchmarkAndDimensionAndMetricSupported]);
}
